import type { FC } from "react";

import { SignInLayout } from "@unauthenticated/signupSignin/components";
import { ForgotPasswordContent } from "@unauthenticated/signupSignin/components/ForgotPasswordContent";

const ForgotPasswordPage: FC = () => {
  return (
    <SignInLayout>
      <ForgotPasswordContent />
    </SignInLayout>
  );
};

export { ForgotPasswordPage };
